module.exports = __webpack_public_path__ + "img/6.d5ee3905.png";